const coreLogicFilters = {
  property_type: {
    id: 'property_type',
    title: 'Type',
    value: '',
    selectValues: [
      { title: 'Please Select...', value: '' },
      { title: 'House', value: 'house' },
      { title: 'Unit', value: 'unit' },
    ],
    type: 'selector',
  },
  bedrooms: {
    comparison: 'eq',
    id: 'bedrooms',
    title: 'Bedrooms',
    value: '',
    type: 'input',
  },
  bathrooms: {
    comparison: 'eq',
    id: 'bathrooms',
    title: 'Bathrooms',
    value: '',
    type: 'input',
  },
  carparks: {
    comparison: 'eq',
    id: 'carparks',
    title: 'Carparks',
    value: '',
    type: 'input',
  },
  price: {
    comparison: 'eq',
    id: 'price',
    title: 'Price',
    value: '',
    type: 'input',
  },
  area: {
    comparison: 'eq',
    id: 'area',
    title: 'Area (m2)',
    value: '',
    type: 'input',
  },
}

export default coreLogicFilters
